<template>
  <div>
    <a-card class="customer-filter">
      <issue-filter-form v-model="filterForm" type="issue" @change="handleSearch" @search="handleSearch" @reset="handleReset" />
    </a-card>
    <a-card title="缺陷列表" size="small" class="filter-data">
      <span slot="extra">
        <a-space>
          <issue-view ref="view" @setFilter="setFilter" />
          <a-button v-tc="{ name: '添加' }" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
        </a-space>
      </span>
      <issue-data-list ref="dataListRef" type="issue" />
    </a-card>
    <issue-edit-modal ref="editModalRef" @ok="onOk" />
  </div>
</template>
<script>
import IssueView from '@/pages/project/issue/components/IssueView';
import IssueDataList from '@/pages/project/issue/components/IssueDataList';
import IssueEditModal from '@/pages/project/issue/components/IssueEditModal';
import IssueFilterForm from '@/pages/project/issue/components/IssueFilterForm';

export default {
  components: { IssueView, IssueEditModal, IssueDataList, IssueFilterForm },
  data() {
    return {
      filterForm: {}
    };
  },
  methods: {
    onAdd() {
      this.$nextTick(() => {
        this.$refs.editModalRef.onOpen({});
      });
    },

    handleSearch(filter) {
      this.$nextTick(() => {
        this.$refs.dataListRef.setFilter(filter);
      });
    },

    setFilter(filter) {
      this.filterForm = {
        ...filter
      };
      this.handleSearch(filter);
    },

    onOk() {
      this.handleSearch(this.filterForm);
    },

    handleReset(filter) {
      this.setFilter({ ...filter });
      this.$nextTick(() => {
        this.$refs.dataListRef.pagination.pageSize = this.$store.getters.pageSize;
        this.$refs.view.resetView();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.add {
  float: left;
  line-height: 32px;
  margin-left: 10px;
}

.filter-data {
  margin-top: 16px;
}

/deep/.customer-filter .ant-card-body {
  padding: 12px !important;
}
</style>
